module.exports = __webpack_public_path__ + "img/Doelgroep - communicatiefoto's.bc6f24f3.webp";